import { useLocation, useNavigate } from 'react-router-dom';

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: 'ホーム' },
    { path: '/chat', icon: 'ri-chat-3-line', activeIcon: 'ri-chat-3-fill', label: 'チャット' },
    { path: '/oshikatsu', icon: 'ri-heart-line', activeIcon: 'ri-heart-fill', label: '推し活' },
    { path: '/memory', icon: 'ri-book-line', activeIcon: 'ri-book-fill', label: 'メモリー' },
    { path: '/settings', icon: 'ri-settings-3-line', activeIcon: 'ri-settings-3-fill', label: '設定' },
  ];

  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-black/35 backdrop-blur-2xl border-t border-white/15 z-50 shadow-[0_-6px_32px_rgba(0,0,0,0.20)]">
      <div className="flex items-center justify-around px-1 py-1 pb-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-250 cursor-pointer whitespace-nowrap ${
                isActive
                  ? 'bg-emerald-400/20'
                  : 'hover:bg-white/10 active:bg-white/15'
              }`}
            >
              {isActive && (
                <span className="absolute top-1 left-1/2 -translate-x-1/2 w-4 h-0.5 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.8)]" />
              )}
              <div className="w-6 h-6 flex items-center justify-center">
                <i
                  className={`${isActive ? item.activeIcon : item.icon} text-[18px] transition-all duration-200 ${
                    isActive
                      ? 'text-emerald-300 drop-shadow-[0_0_8px_rgba(52,211,153,0.6)]'
                      : 'text-white/50'
                  }`}
                />
              </div>
              <span
                className={`text-[10px] font-medium transition-all duration-200 ${
                  isActive ? 'text-emerald-300 font-semibold' : 'text-white/45'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
